// @flow

import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';

import {colors} from '../../../../assets/styles/colors';

import type {TooltipLink} from '../../types';
import type {Theme} from '@material-ui/core';
import {Link} from 'react-router-dom';

type Props = {
  items: TooltipLink[],
  showDivider?: boolean,
};

const useStyles = makeStyles((theme: Theme) => ({
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    pointerEvents: 'auto',
  },
  tooltipDivider: {
    margin: 0,
    backgroundColor: '#EEEEF2',
  },
  tooltipText: {
    fontSize: 12,
    fontWeight: 500,
  },
  link: {
    textDecoration: 'none',
    padding: '.5rem',
    borderBottom: `1px solid ${colors.grey300}`,
    color: colors.grey800,

    '&:hover': {
      color: colors.primary,
    },

    '&:last-child': {
      borderBottom: 'none',
    },
  },
}));

export default function TooltipItem(props: Props) {
  const {items} = props;
  const classes = useStyles();
  return (
    <div className={classes.tooltipContent}>
      {items
        .filter(el => !el.hide)
        .map((el, idx) => {
          return (
            <Link
              key={`tooltip-item-${el.path}`}
              to={el.path}
              className={classes.link}
            >
              <Typography className={classes.tooltipText}>{el.name}</Typography>
            </Link>
          );
        })}
    </div>
  );
}
